<template>
  <div style="background-color: #fafafa;padding: 20px">

    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Package' }" >提成规则管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/SavePackage' }" >新增提成规则</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="font-size: 25px;margin-top: 15px;width: 100%">
      <p>新增提成规则</p>
    </div>

    <div style="margin: 20px auto;max-width: 1200px;min-width: 768px" v-loading="loading">
      <el-form :model="packageVo" :rules="saveRule" ref="savePackage" label-width="100px">
        <el-row>
          <el-col :lg="7" :sm="12">
            <el-form-item label="规则名称" prop="packageName" ref="packageName">
              <el-input style="min-width: 150px" v-model="packageVo.packageName" placeholder="请输入规则名称" type="text" clearable maxlength="50"/>
            </el-form-item>
          </el-col>
          <el-col :lg="10" :sm="12" >
            <el-form-item label="供应商" prop="supplierId" ref="supplierId">
              <el-select v-model="packageVo.supplierId"
                         @change="supplierChange"
                         filterable
                         class="inline-input"
                         style="width: 300px"
                         placeholder="请选择供应商">
                <el-option
                    v-for="item in suppliers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附加文案" prop="packageDescription">
              <el-input
                type="textarea"
                v-model="packageVo.packageDescription"
                style="width: 100%"
                :autosize="{ minRows: 2}"
                :maxlength="100"
                placeholder="请输入附加文案">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :sm="12">
            <el-form-item label="生效时间" prop="rang" ref="rang">
              <el-date-picker
                type="daterange"
                v-model="packageVo.rang"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="-"
                unlink-panels
                style="width: 100%;min-width: 250px"
                :clearable="false"
                :editable="false"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="叠加设定">
              <div style="float: left;margin-right: 10px">
<!--                <el-checkbox v-model="packageVo.overlayBetweenPackages" :true-label="1" :false-label="0">规则内可互相叠加</el-checkbox>-->
                <el-checkbox v-model="packageVo.overlayInPackage" :true-label="1" :false-label="0">规则间可互相叠加</el-checkbox>
              </div>
              <div style="background-color: rgb(242,242,242);float: left;margin-left: 32px">
                <i class="el-icon-warning" style="color: orange;margin-left: 10px;font-size: 14px"/>
                <span style="font-size: 14px;color: #EF6C00">
                  &nbsp;不可叠加的规则优先级将会高于可叠加优先级，提成方案冲突且不可叠加时，将暂时停止导购的相关结算流程&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div style="margin-left: 30px">
        <el-form :model="packageVo.activitys" :rules="activityRule" :disabled="!packageVo.supplierId" ref="activity" label-width="80px" style="margin-bottom: 50px;">
          <el-row v-for="(activity,index) in packageVo.activitys" :key="index" style="margin-bottom: 20px;" :style="{marginTop: index > 0?'50px':''}">
            <el-col style="height: 30px">
              <h2>提成方案{{index+1}}</h2>
            </el-col>
            <el-col :lg="8" :sm="12">
              <el-form-item label="方案名称" :rules="activityRule.activityName" :prop="index + '.activityName'" :ref="index + '.activityName'">
                <el-input style="min-width: 150px" v-model="activity.activityName" placeholder="请输入方案名称" type="text" clearable maxlength="50"/>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :sm="4">
              <el-form-item label="简单方案" prop="activityType">
                <el-checkbox v-model="activity.activityType" :true-label="1" :false-label="0"/>
              </el-form-item>
            </el-col>
            <el-col :lg="8" :sm="4">
              <el-button style="float: right" size="small" :disabled="packageVo.activitys.length <= 1 && packageActivitys.length == 0" @click="delActivity(index)">删除</el-button>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附加文案" prop="activityDescription">
                <el-input
                  type="textarea"
                  style="width: 100%"
                  v-model="activity.activityDescription"
                  :autosize="{ minRows: 2}"
                  :maxlength="100"
                  placeholder="请输入附加文案">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24" v-if="activity.activityType == 0">
              <el-form-item label="结算周期" prop="cycleDay">
                <el-radio-group class="activityGroup" v-model="activity.cycleDay">
                  <el-radio :label="1">每天</el-radio>
                  <el-radio :label="7">自然周</el-radio>
                  <el-radio :label="30">自然月</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24" v-if="activity.activityType == 0">
              <el-form-item label="奖励基准" prop="rewardAlgorithm.rewardBenchmark">
                <el-radio-group class="activityGroup" v-model="activity.rewardAlgorithm.rewardBenchmark">
                  <el-radio :label="'tc_1'">销售数</el-radio>
                  <el-radio :label="'tc_2'">金额比例</el-radio>
                  <el-radio :label="'tc_3'">单笔固定金额</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24" v-if="activity.activityType == 0">
              <el-form-item label="组合方式" prop="rewardBenchmark.combinationMode">
                <el-radio-group class="activityGroup" v-model="activity.rewardAlgorithm.combinationMode">
                  <el-radio :label="'zh_dp'">单品</el-radio>
                  <el-radio :label="'zh_ry'">任意组合</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度规则" prop="rewardBenchmark.gradientRule">
                <el-radio-group class="activityGroup" v-model="activity.rewardAlgorithm.gradientRule">
                  <el-radio :label="'js_period'">周期内加总</el-radio>
                  <el-radio :label="'js_ticket'">单张小票结算</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :lg="12" :sm="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度基准" prop="rewardBenchmark.gradientBenchmark">
                <el-radio-group class="activityGroup" v-model="activity.rewardAlgorithm.gradientBenchmark">
                  <el-radio :label="'mk_1'">销售数</el-radio>
                  <el-radio :label="'mk_2'">销售金额</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度列表" :rules="activityRule['rewardAlgorithm.gradientList']" :prop="index + '.rewardAlgorithm.gradientList'" :ref="index + '.rewardAlgorithm_gradientList'">
                <el-button style="float: right" size="small" @click="addGradient(activity)">添加梯度</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-table style="margin-bottom: 10px" :data="activity.rewardAlgorithm.gradientList">
                <el-table-column label="梯度" align="center">
                  <template slot-scope="scope">
                    梯度{{scope.$index + 1}}
                  </template>
                </el-table-column>
                <el-table-column label="梯度指标" align="center">
                  <template slot-scope="scope">
                    <el-input-number size="mini" v-model="scope.row.quota" :precision="0" :step="1" :min="0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="奖励标准" align="center">
                  <template slot-scope="scope">
                    <el-input-number size="mini" v-model="scope.row.rewardBonus" :precision="2" :step="1" :min="0"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button style="height: 40px;width: 120px;" type="text" icon="el-icon-delete" @click="delGradient(activity,scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="24">
              <el-form-item label="包含商品" :rules="activityRule.products" :prop="index + '.products'" :ref="index + '.products'">
                <div style="float: right">
                  <!-- action：上传的地址，on-change：无论上传成功还是失败都会执行的钩子
                       on-remove: 删除文件的钩子，on-exceed：文件超出限制的钩子，
                       limit：最大允许上传个数，accept：接收上传的文件类型，
                       auto-upload：是否开启选取文件后立即上传-->
                  <el-upload
                    class="upload-demo"
                    action=""
                    :on-change="(file, fileList) => {handleChange(file,fileList,index)}"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :limit="limitUpload"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    :auto-upload="false">
                    <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px" :disabled="!packageVo.supplierId" :loading="loading">点击上传</el-button>
                  </el-upload>
                </div>
                <div style="float: right;padding: 0px 10px">
                  <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px" :loading="loading" :disabled="!packageVo.supplierId" @click="exportExcel(index)">下载模板</el-button>
                </div>
                  <div style="float: right;padding: 0px 10px">
                      <el-button style="color: white; letiant:'outlined';border-color: #FF6633; background-color: #FF6633;margin-bottom: 10px" @click="addActivityProduct(index)">添加产品</el-button>
                  </div>
                <div style="float: right">
                  <el-select placeholder="请选择商品" value-key="productId"
                             :collapse-tags="activity.productsTemp.length > 30" filterable multiple v-model="activity.productsTemp">
                    <select-all-option v-model="activity.productsTemp" group-value="children" :data="activity.category"/>
                    <el-option-group
                      v-for="group in activity.category"
                      :key="group.id"
                      :label="group.name">
                      <el-option
                        v-for="item in group.children"
                        :key="item.productId"
                        :label="item.productName"
                        :value="item">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div style="float: right;margin-right: 10px">
                  <el-select placeholder="请选择品类" value-key="id" multiple v-model="activity.category">
                    <select-all-option v-model="activity.category" :data="products"/>
                    <el-option
                      v-for="item in products"
                      :key="item.id"
                      :label="item.name"
                      :value="item">
                    </el-option>
                  </el-select>
                </div>
                <div style="float: right;margin-right: 10px">
                  <el-select v-model="activity.parentBrand"
                             @change="(value) => parentBrandChang(value, 'brand',index)"
                             filterable
                             placeholder="请选择品牌">
                    <el-option
                        v-for="item in parentBrands"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-table :data="activity.products" :row-class-name="tableRowClassName">
                  <el-table-column label="品牌" align="center" prop="parentBrand"/>
                <el-table-column label="品类" show-overflow-tooltip align="center" prop="category"/>
                <el-table-column label="商品" show-overflow-tooltip align="center" prop="productName"/>
                <el-table-column label="规格" show-overflow-tooltip align="center" prop="specification"/>
                <el-table-column label="售价" show-overflow-tooltip align="center" prop="retailPrice"/>
                <el-table-column label="提成" align="center" v-if="activity.activityType == 1">
                  <template slot-scope="scope">
                    <el-input-number size="mini" v-model="scope.row.simpleBonus" :precision="2" :step="1" :min="0"></el-input-number>
                  </template>
                </el-table-column>
                  <el-table-column label="操作" align="center" width="70">
                      <template slot-scope="scope">
                          <el-button type="danger" icon="el-icon-delete" @click="() => activity.products.splice(scope.$index, 1)" circle></el-button>
                      </template>
                  </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-button style="float: right;margin-top: 20px" size="small" @click="addActivity">+ 添加方案</el-button>
        </el-form>
        <el-form :model="packageActivitys" label-width="80px" class="activityForm" style="margin-top: 50px">
          <el-row v-for="(activity,index) in packageActivitys" :key="index" :style="{marginTop: index > 0?'50px':''}">
            <el-col :span="24">
              <h2>已有方案{{index+1}}</h2>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案名称">
                {{activity.activityName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="简单方案">
                {{activity.activityType == 1 ?'是':'否'}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附加文案">
                {{activity.activityDescription}}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="结算周期">
                {{activity.cycleDay | cycleDayFilter}}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="奖励基准">
                {{activity.rewardAlgorithm.rewardBenchmark | rewardBenchmarkFilter}}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="组合方式">
                {{activity.rewardAlgorithm.combinationMode | combinationModeFilter}}
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="activity.activityType == 0">
              <el-form-item label="梯度规则">
                {{activity.rewardAlgorithm.gradientRule | gradientRuleFilter}}
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度基准">
                {{activity.rewardAlgorithm.gradientBenchmark | gradientBenchmarkFilter}}
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-form-item label="梯度列表"/>
            </el-col>
            <el-col :span="24" v-if="activity.activityType == 0">
              <el-table style="margin-bottom: 10px" :data="activity.rewardAlgorithm.gradientList">
                <el-table-column label="梯度" show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    梯度{{scope.$index + 1}}
                  </template>
                </el-table-column>
                <el-table-column label="梯度指标" show-overflow-tooltip align="center" prop="quota"/>
                <el-table-column label="奖励标准" show-overflow-tooltip align="center" prop="rewardBonus"/>
              </el-table>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商品列表"/>
            </el-col>
            <el-col :span="24">
              <el-table :data="activity.products">
                <el-table-column label="品牌" show-overflow-tooltip align="center">
                  <template slot-scope="scope">
                    {{packageVo.parentBrand}}
                  </template>
                </el-table-column>
                <el-table-column label="品类" show-overflow-tooltip align="center" prop="category"/>
                <el-table-column label="商品" show-overflow-tooltip align="center" prop="productName"/>
                <el-table-column label="规格" show-overflow-tooltip align="center" prop="specification"/>
                <el-table-column label="售价" show-overflow-tooltip align="center" prop="retailPrice"/>
                <el-table-column label="提成" show-overflow-tooltip align="center" v-if="activity.activityType == 1" prop="simpleBonus"/>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
      </div>
        <div style="height: 50px;width: 100%"></div>
    </div>
      <div style="height: 100px;width: 100%"></div>
      <div align="center" class="submitButton">
          <el-button style="background-color: darkorange; color: white;" @click="submit">提交并进入规则范围设置</el-button>
      </div>
  </div>
</template>

<script>
import {activityInit,parentBrandChang,addPackageSubmit} from "@/api/package"
import {MessageBox} from "element-ui"
import XLSX from "xlsx"
import FileSaver from "file-saver"
import selectAllOption from '@/components/selectAllOption'

export default {
  name: "SavePackage",
  components: {selectAllOption},
  data(){
    return {
      // 上传最大长度限制
      limitUpload:1,
      fileTemp:null,
      file:null,

      token: undefined,
      // 表单验证
      saveRule: {
        packageName: [
          { required: true, message: "规则名不能为空", trigger: "blur" }
        ],
        supplierId: [
          { required: true, message: "供应商不能为空", trigger: "blur" }
        ],
        parentBrand: [
          { required: true, message: "品牌不能为空", trigger: "blur" }
        ],
        rang: [
          { required: true, message: "生效时间不能为空", trigger: "blur" }
        ]
      },
      activityRule: {
        activityName: [
          { required: true, message: "活动名不能为空", trigger: "blur" }
        ],
        products: [
          { type: 'array', required: true, message: '商品不能为空' }
        ],
        'rewardAlgorithm.gradientList': [
          { type: 'array', required: true, message: "梯度不能为空" }
        ]
      },
      // 表单数据
      packageVo: {
        sourcePackageId: undefined,// 复制规则id
        packageName: undefined,// 规则名
        supplierId: undefined,// 供应商id
        parentBrand: undefined,// 品牌
        packageDescription: undefined,// 规则描述
        rang: [],
        overlayInPackage: 0,// 规则内叠加0不叠加1叠加
        overlayBetweenPackages: 0,// 规则间叠加0不叠加1叠加
        activitys: [],
        activityed: []
      },
      // 供应商数组
      suppliers: [],
      // 品牌数组
      parentBrands: [],
      // 已有方案数据
      activitys: [],
      // 全局遮罩层
      loading: false,
      // 商品下拉框
      products: [],
      packageActivitys: [],
      success: false,
      simpleIsComplex: 0,
      parentbrand: [],
      currentUrl: ""

    }
  },
  mounted() {
    // 记录当前页面url
    this.currentUrl = window.location.href
  },
  methods: {
    queryParentBrand(queryString,cb){
      var parentBrands = this.parentBrands
      var results = queryString ? parentBrands.filter(this.createFilter(queryString)) : parentBrands;
      cb(results)
    },

    querySupplier(queryString, cb) {
      var suppliers = this.suppliers;
      if (queryString == ''){
        cb(suppliers);
        return
      }
      var results = queryString ? suppliers.filter(this.createFilter(queryString)) : suppliers;
      cb(results)
    },
      //添加方案产品
      addActivityProduct(index) {
          let activity = this.packageVo.activitys[index]
          let products = activity.productsTemp.filter(tempProduct => !activity.products.some(product => product.productId === tempProduct.productId))
          products = products.concat(activity.products.filter(tempProduct => activity.productsTemp.some(product => product.productId === tempProduct.productId)))
          products.forEach(item => item.status = -1)
          activity.products = activity.products.filter(aProduct => !products.some(product => product.productId === aProduct.productId))
          activity.products.forEach(item => item.status = 0)
          activity.products = products.concat(activity.products);
          activity.productsTemp = []
          activity.category = []
      },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    exportExcel(index){
      let  name = "新增提成规则"     // 名称
      let  worBook =XLSX.utils.book_new()     // 创建一个新的工作簿对象
      let workSheet = []
      let workSheets = []
      // 构建需要导出的数据
      this.loading = true
      let parentBrand = this.parentBrands.map(item => item.name).join(",")
      parentBrandChang(this.packageVo.supplierId,parentBrand,this.token).then(({data}) => {
        let {products} = data.date
        products.forEach(item => {
          item.children.forEach(ch => {
            workSheets.push({
              '品牌' : ch.parentBrand,
              '品类' : ch.category,
              '商品' : ch.productName,
              'barcode' : ch.barcode,
              '商品id' : ch.productId,
              '规格' : ch.specification,
              '售价' : ch.retailPrice,
              '提成' : ch.simpleBonus
            })
          })
        })
        workSheets.sort((a, b) => {
          // 首先按 parentBrand 排序
          if (a['品牌'] < b['品牌']) return -1;
          if (a['品牌'] > b['品牌']) return 1;
          // 如果 parentBrand 相同，则按 category 排序
          if (a['品类'] < b['品类']) return -1;
          if (a['品类'] > b['品类']) return 1;
          return 0; // 如果两者都相同
        });
        // 将js对象数组装换为工作表
        workSheet = XLSX.utils.json_to_sheet(Object.values(workSheets))
        // 列宽设置
        workSheet["!cols"] = [{width:10},{width:15},{width:20},{width:20},{width:40},{width:20},{width:10},{width:10}];
        XLSX.utils.book_append_sheet(worBook,workSheet,"服务费")
        // 写入
        let wbout = XLSX.write(worBook, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        })
        let tmpDown = new Blob([wbout], {
          type: "application/octet-stream"
        });
        FileSaver.saveAs(tmpDown,name +"_"+ ".xlsx")
        return wbout
      }).finally(() => this.loading = false)
    },
    // 供应商切换
    supplierChange(supplierId){
      if (!this.packageVo.supplierId){
        this.packageVo.parentBrand = []
      }else {
        let sup = this.packageVo.supplierId
        this.parentBrands = this.suppliers.find(s => s.id == sup).children
        this.packageVo.parentBrand = []
      }
      this.activityFormClear(true)
    },
    // 文件状态改变时的钩子(在上传文件后无论是失败还是成功都会调用该方法)
    handleChange(file, fileList,index){
      this.fileTemp = file.raw;
      if(this.fileTemp){
        if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          || (this.fileTemp.type == 'application/vnd.ms-excel')){
          this.importfxx(this.fileTemp,index);
        } else {
          this.$message({
            type:'warning',
            message:'上传文件格式错误，请删除后重新上传！'
          })
        }
      } else {
        this.$message({
          type:'warning',
          message:'请上传文件！'
        })
      }
    },
    // 文件超出限制的钩子
    handleExceed(){
      this.$message({
        type:'warning',
        message:'一次只能上传一个文件！'
      })
      return;
    },
    // 文件删除的钩子
    handleRemove(file,fileList){
      this.fileTemp = null
    },
    // 读取文件中的内容
    importfxx(obj,index) {
      let _this = this;
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function(f) {
        var binary = "";
        //是否将文件读取为二进制字符串
        var rABS = false;
        //读取完成的数据
        var wb;
        var outdata;
        var reader = new FileReader();
        reader.onload = function(e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64"
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary"
            });
          }
          //outdata就是最终想要的东西
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
          //此处对数据进行处理
          let arr = [];
          outdata.map(v => {
            if (v['提成'] > 0) {
              let obj = {}
              obj.parentBrand = v['品牌']
              obj.category = v['品类']
              obj.productId = v['商品id']
              obj.productName = v['商品']
              obj.barcode = v['barcode']
              obj.specification = v['规格']
              obj.retailPrice = v['售价']
              var ma_tc = (v['提成'] * 100).toFixed(2)
              obj.simpleBonus = Math.round(ma_tc)/100
              var num1 = 0
              _this.packageVo.activitys[index].products.forEach(pr => {
                if (pr.productId === obj.productId) {
                  num1++
                  pr.simpleBonus = obj.simpleBonus
                }
              })
              if (num1 === 0) {
                _this.packageVo.activitys[index].products.push(obj)
              }
              if (!arr[obj.category]) {
                arr[obj.category] = obj.category
                _this.products.forEach(p => {
                  if (p.id === obj.category) {
                    var num = 0
                    _this.packageVo.activitys[index].category.forEach(ca => {
                      if (ca.id === obj.category){
                        num++
                      }
                    })
                    if (num === 0) {
                      _this.packageVo.activitys[index].category.push(p)
                    }
                  }
                })
              }
            }
          });
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    // 品牌切换
    parentBrandChang(value,type,index){
      this.loading = true
      parentBrandChang(this.packageVo.supplierId,value,this.token)
        .then(({data}) => {
          let {products,activitys} = data.date
          if (type === 'brand') {
            this.products = products
            this.packageVo.activitys[index].category = []
          }else if (type === 'activity'){
            this.activitys = activitys
            this.activityFormClear(false)
          }
        }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.loading = false)
    },
    // 添加活动
    addActivity(){
      let activity = {
        activityName: undefined,// 活动名称
        activityDescription: undefined,// 活动描述
        activityType: 1,// 0复杂方案1简单提成方案
        cycleDay: 1,// 结算周期
        // 结算规则
        rewardAlgorithm: {
          rewardBenchmark: 'tc_1',// 奖励基准
          combinationMode: 'zh_dp',// 组合方式
          gradientRule: 'js_period',// 梯度规则
          gradientBenchmark: 'mk_1',// 梯度基准
          gradientList: [{quota: 0,rewardBonus: 0.00}]// 梯度表
        },
        products: [],// 商品
        category: [],
        productsTemp: []
      }
      this.packageVo.activitys.push(activity)
      this.packageVo.activitys = JSON.parse(JSON.stringify(this.packageVo.activitys))
    },
    // 删除活动
    delActivity(index){
      this.packageVo.activitys.splice(index,1)
    },
    // 活动表单清空
    activityFormClear(b){
      if (b)
        this.activitys = []
      this.packageVo.activitys.forEach(a => {
        a.products = []
        a.category = []
      })
    },
    // 活动添加梯度
    addGradient(activity){
      if (activity.activityType == 0){
        activity.rewardAlgorithm.gradientList.push({quota: 0,rewardBonus: 0.00})
      }
    },
    // 活动删除梯度
    delGradient(activity,index){
      if (activity.activityType == 0){
        activity.rewardAlgorithm.gradientList.splice(index,1)
      }
    },
    // 规则提交
    addsubmit() {
      this.loading = true
      let packageVo = {
        sourcePackageId: this.packageVo.sourcePackageId,
        packageName: this.packageVo.packageName,
        supplierId: this.packageVo.supplierId,
        parentBrand: this.packageVo.parentBrand.join(','),
        packageDescription: this.packageVo.packageDescription,
        startTime: this.packageVo.rang[0],
        endTime: this.packageVo.rang[1],
        overlayInPackage: this.packageVo.overlayInPackage,
        overlayBetweenPackages: this.packageVo.overlayBetweenPackages,
        activitys: this.packageVo.activitys,
        activityed: this.packageActivitys.map(a => a.activityId)
      }
      addPackageSubmit(packageVo,this.token).then(({data}) => {
        let {code,msg,date} = data
        if (code == 200){
          this.$notify.success({
            title: '成功',
            message: '添加成功',
            position: 'bottom-right'
          })
          this.success = true
          localStorage.setItem('packageId', date);
          this.$router.replace({path: '/Package',query:{supplierId:packageVo.supplierId}})
        }else {
          this.$notify.error({
            title: '错误',
            message: msg,
            position: 'bottom-right'
          })
        }
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '添加失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.loading = false)
    },
    // 判断提成金额是否为0
    setmealIsNull() {
      var counts = 0
      var counts2 = 0
      // 记录提成金额为0的商品次数
      this.packageVo.activitys.forEach(a => {
        if (a.activityType === 1) {
          a.products.forEach(p => {
            if (p.simpleBonus === 0) {
              counts++
            }
          })
        }
        if (a.activityType === 0) {
          a.rewardAlgorithm.gradientList.forEach(g => {
            if (g.rewardBonus === 0) {
              counts2++
            }
          })
        }
      })
      if (counts === 0 && counts2 === 0) {
        this.addsubmit()
      } else {
        var num = counts + counts2;
        MessageBox.confirm('检测到有'+num+'个商品提成金额为0，是否继续提交?', '提示', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false
        }).then(() => {
          this.addsubmit()
        })
      }
    },
    // 简单方案提交
    submit(){
      this.$refs["savePackage"].validate((valid,obj) => {
        if (valid){
          var num = 0
          var num2 = 0
          this.packageVo.activitys.forEach(a => {
            // 简单方案
            if (a.activityType === 1) {
              // 记录表单是否有数据
              if (a.products[0] !== undefined || a.products.length > 0) {
                num++
              }
            }
            // 复杂方案
            if (a.activityType === 0) {
              // 记录表单是否有数据
              if (a.rewardAlgorithm.gradientList[0] !== undefined || a.a.rewardAlgorithm.gradientList.length > 0) {
                num2++
              }
            }
          })
          if (num > 0) {
            // 过滤数组中为空的数据
            let products = this.packageVo.activitys.filter((item) => {
              return item.products[0] !== undefined || item.activityName !== undefined
            })
            this.packageVo.activitys = products
            var isOk = 0
            this.packageVo.activitys.forEach(a => {
              if (a.activityName === undefined || a.activityName === "" || a.products[0].productName === undefined || a.products[0].productName === "" || a.products[0].category === undefined || a.products[0].category === "") {
                isOk++
              }
            })
            this.$refs["activity"].validate((valid2,obj2) => {
              if (valid2 || isOk === 0){
                this.setmealIsNull()
              }else {
                this.validateScroll(obj2)
              }
            })
          } else {
            this.$refs["activity"].validate((valid2,obj2) => {
              if (valid2){
                this.setmealIsNull()
              }else {
                this.validateScroll(obj2)
              }
            })
          }
        }else {
          this.validateScroll(obj)
        }
      })
    },
    beforeunloadHandler (e) {
      e = e || window.event
      if (e)
        e.returnValue = '关闭提示'
      return '关闭提示'
    },
    // 表单验证动画
    validateScroll(obj){
      for (let i in obj) {
        let dom = this.$refs[i]
        if (Array.isArray(dom))
          dom = dom[0]
        dom.$el.scrollIntoView({　　//滚动到指定节点
          block: 'center',　　　　　//值有start,center,end，nearest，当前显示在视图区域中间
          behavior: 'smooth'　　　　//值有auto、instant,smooth，缓动动画（当前是慢速的）
        })
        break;
      }
    },
    init() {
      let packageInfo = this.$route.query.packageInfo
      if (packageInfo) {
        packageInfo = JSON.parse(decodeURIComponent(packageInfo));
        this.packageVo = {
          sourcePackageId: packageInfo.packageId,
          packageName: packageInfo.packageName + '-' + this.getCurrentDateString(),
          supplierId: packageInfo.supplierId,
          parentBrand: packageInfo.parentBrand,
          packageDescription: packageInfo.packageDescription,
          rang: [packageInfo.startTime,packageInfo.endTime],
          overlayInPackage: packageInfo.overlayInPackage,
          overlayBetweenPackages: packageInfo.overlayBetweenPackages,
          activitys: packageInfo.activitys.map(item => {item.productsTemp = [];return item}),
          activityed: []
        }
        this.parentbrand = packageInfo.parentBrand
        this.parentBrands = this.suppliers.find(s => s.id == packageInfo.supplierId).children
        parentBrandChang(this.packageVo.supplierId,this.packageVo.parentBrand,this.token)
        .then(({data}) => {
          let {products} = data.date
          this.products = products
          this.activitys = []
          this.packageVo.activitys.forEach(item => {
            item.category = []
          })
          this.packageVo.activitys = JSON.parse(JSON.stringify(this.packageVo.activitys))
        })
      }
    },
    getCurrentDateString() {
        const date = new Date();
        const year = String(date.getFullYear()).slice(-2); // 获取年份的后两位
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 获取月份，注意要加1，并补零
        const day = String(date.getDate()).padStart(2, '0'); // 获取日期，并补零
        return `${year}.${month}.${day}`; // 返回格式化后的字符串
    },
      tableRowClassName({row, rowIndex}) {
          if (row.status === -1) {
              return 'temp-row'
          }
          return ''
      }
  },
  created() {
    this.loading = true
    this.token = localStorage.getItem('token')
    window.addEventListener('beforeunload', this.beforeunloadHandler)
    this.addActivity()
    activityInit(this.token).then(({data}) => {
      let {date} = data
      this.suppliers = date
      this.init()
    }).catch(error => {
      let status = error.response.status;
      if (status == 500){
        this.$notify.error({
          title: '错误',
          message: '查询失败，请联系管理员',
          position: 'bottom-right'
        })
      }
    }).finally(() => this.loading = false)
  },
  beforeRouteLeave : function (to,from,next){
    if (!this.success){
      setTimeout(()=>{
        MessageBox.confirm('确认离开规则添加？系统可能不会保存您所做的更改！', '提示', {
          confirmButtonText: '离开',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false
        }).then(() => {
          next()
        }).catch(() => {
          next(false)
        })
      },1)
    }else {
      next()
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload',this.beforeunloadHandler)
  },
  filters: {
    cycleDayFilter:function(value){
      switch (value){
        case 1: return '每天'
        case 7: return '自然周'
        case 30: return '自然月'
      }
    },
    rewardBenchmarkFilter:function(value){
      switch (value){
        case 'tc_1': return '销售数'
        case 'tc_2': return '金额比例'
        case 'tc_3': return '单笔固定金额'
      }
    },
    combinationModeFilter:function(value){
      switch (value){
        case 'zh_dp': return '单品'
        case 'zh_ry': return '任意组合'
      }
    },
    gradientRuleFilter:function(value){
      switch (value){
        case 'js_period': return '周期内加总'
        case 'js_ticket': return '单张小票结算'
      }
    },
    gradientBenchmarkFilter:function(value){
      switch (value){
        case 'mk_1': return '销售数'
        case 'mk_2': return '销售金额'
      }
    }
  }
}
</script>

<style>
.activityForm /deep/ .el-form-item {
  margin-bottom: 10px;
}


.activityGroup /deep/ .el-radio {
  color: #606266;
  cursor: pointer;
  width: 100px;
}

.el-table .temp-row {
    background: oldlace;
}

.submitButton {
    position: fixed;
    bottom: 0;
    left: 55%;
    width: 80%;
    transform: translateX(-50%);
    z-index: 1000;
    background-color: #fafafa;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
